import Router, { useRouter } from 'next/router';
import { useCallback, useContext, useEffect } from 'react';
import { AnalyticsProvider as DapperAnalyticsProvider, AnalyticsContext } from '@dapperlabs/react-analytics';
import { captureException } from 'src/lib/sentry';

function useAnalytics() {
  const {
    analyticsReady: isReady,
    track,
    trackPageView,
    identify,
    alias,
  } = useContext(AnalyticsContext);

  const trackClick = (trackingId, trackingProperties = {}) => {
    try {
      if (!!trackingId) {
        track(trackingId, trackingProperties);
      }
    } catch (error) {
      captureException(error);
    }
  };

  const trackPage = useCallback((trackingProperties = {}) => {
    try {
      trackPageView({
        userAgent: navigator.userAgent,
        ...trackingProperties,
      });
    } catch (error) {
      captureException(error);
    }
  }, [trackPageView]);

  return {
    track: trackClick,
    trackPageView: trackPage,
    isAnalyticsReady: isReady,
    alias,
    identify,
  };
}

/**
 * @note: PageAnalytics should only used in _app
 */
function PageAnalytics() {
  const { trackPageView } = useAnalytics();
  const router = useRouter();

  useEffect(() => {
    trackPageView()
    Router.events.on('routeChangeComplete', () => {
      trackPageView()
    })
    return () => {
      Router.events.off('routeChangeComplete', trackPageView)
    }
  }, [trackPageView]);

  return null;
}

function AnalyticsProvider(props) {
  return (
    <DapperAnalyticsProvider segmentWriteToken={process.env.NEXT_PUBLIC_SEGMENT_WRITE_TOKEN}>
      <PageAnalytics />
      {props.children}
    </DapperAnalyticsProvider>
  )
}

export {
  AnalyticsProvider,
  PageAnalytics,
  useAnalytics
};
